import { Component } from '@angular/core';
import {AsyncPipe, DatePipe, NgForOf, NgIf} from "@angular/common";
import {Observable} from "rxjs";
import {AuthService} from "../../../services/auth.service";
import {Store} from "@ngrx/store";
import {AppState} from "../../../state/app.state";
import {HeaderService} from "../../../services/header.service";
import {Router} from "@angular/router";
import {Actions} from "@ngrx/effects";

import * as WorkspaceActions from '../../../state/workspace/workspace.actions';
import * as WorkspaceSelectors from '../../../state/workspace/workspace.selectors';
import { Workspace } from '../../../models/workspace.model';

@Component({
  selector: 'app-dashboard-workspaces',
  standalone: true,
  imports: [
    AsyncPipe,
    DatePipe,
    NgForOf,
    NgIf
  ],
  templateUrl: './dashboard-workspaces.component.html',
  styleUrl: './dashboard-workspaces.component.scss'
})
export class DashboardWorkspacesComponent {

  workspaces$: Observable<Workspace[]>;
  loading$: Observable<boolean>;
  error$: Observable<string | null>;

  constructor(
    private authService: AuthService,
    private store: Store<AppState>,
    private headerService: HeaderService,
    private router: Router,
    private actions$: Actions
  ) {
    // Initialize observables
    this.workspaces$ = this.store.select(WorkspaceSelectors.selectAllWorkspaces);
    this.loading$ = this.store.select(WorkspaceSelectors.selectWorkspacesLoading);
    this.error$ = this.store.select(WorkspaceSelectors.selectWorkspacesError);
  }


  ngOnInit(): void {

    // Load workspaces from API
    this.store.dispatch(WorkspaceActions.loadWorkspaces());

  }

  selectWorkspace(workspace: Workspace): void {
    console.log('Selected workspace:', workspace);
    this.store.dispatch(WorkspaceActions.selectWorkspace({ workspace }));
    this.router.navigate(['/workspaces', workspace.id]);
  }

}
